import React, { useState } from 'react';
import { Keys, set as lsSet } from '../lib/storage';

export default function AuthScreen({ onAuth }) {
  const [tok, setTok] = useState('');
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState(false);

  const login = async (e) => {
    e.preventDefault();
    if (!tok.trim()) return;
    setBusy(true); setErr('');
    try {
      // /api/templates ist auth-protected → 200 = Token gültig
      const r = await fetch('/api/templates', {
        headers: { Authorization: `Bearer ${tok.trim()}` },
      });
      if (r.status === 401) { setErr('Ungültiges Token.'); return; }
      if (!r.ok)            { setErr(`Server-Fehler: ${r.status}`); return; }
      lsSet(Keys.TOKEN, tok.trim());
      onAuth(tok.trim());
    } catch {
      setErr('Server nicht erreichbar.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="auth-screen">
      <div className="auth-card">
        <div className="auth-logo">
          <div className="auth-logo-frame">
            <img src="/ako2me-logo.png" alt="AKO2ME" className="auth-logo-img" />
          </div>
        </div>
        <p className="auth-sub">chat.ako2me.com · Privater Zugang</p>
        <form onSubmit={login} className="auth-form">
          <label className="field-label">Bearer Token</label>
          <input
            type="password"
            value={tok}
            onChange={e => setTok(e.target.value)}
            placeholder="Token eingeben…"
            autoFocus
            className="field-input"
          />
          {err && <p className="auth-error">{err}</p>}
          <button type="submit" disabled={busy} className="btn-primary btn-full" title="Mit API-Token anmelden">
            {busy ? 'Prüfe…' : 'Anmelden'}
          </button>
        </form>
      </div>
    </div>
  );
}
